<div class="splash">
    <div class="logo animated fadeInLeft">
        e<span><img class="o" src="../../assets/img/o.png"><img class="i animated bounceInLeft wobble" src="../../assets/img/i.png"></span>pso
    </div>
    
    <div class="title animated  fadeInRight color-primary">{{companyInfo.motto}}</div>
</div>